import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=1958ddee&scoped=true&"
import script from "./AppTabs.vue?vue&type=script&lang=js&"
export * from "./AppTabs.vue?vue&type=script&lang=js&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=1958ddee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958ddee",
  null
  
)

export default component.exports